import * as React from "react";
import {useRef} from "react";
import {useLightMode} from "@/app/AppThemeContext";
import {Container} from "@mui/material";
import {Layout, LayoutItem} from "@/lib/components/Layout";
import {Header} from "@/app/header/Header";
import {Section1} from "@/pages/landing-page/sections/Section1";
import {Section8} from "@/pages/landing-page/sections/Section8";
import {Section7} from "./sections/Section7";
import {Section6} from "./sections/Section6";
import {Section3} from "@/pages/landing-page/sections/Section3";
import {Section2} from "@/pages/landing-page/sections/Section2";
import {Section4} from "@/pages/landing-page/sections/Section4";
import {Section5} from "@/pages/landing-page/sections/Section5";
import {useMatomoTracker} from "@/pages/landing-page/utils/MatomoTracker";
import {Section1a} from "@/pages/landing-page/sections/Section1a";
import {loadLandingPageData} from "@/pages/landing-page/landing-page-data";
import {useTranslation} from "react-i18next";
import {resolveApiLanguage} from "@/app/locale/anonymousLanguage";

export const LandingPage = () => {
    useLightMode();
    useMatomoTracker();

    const { i18n } = useTranslation();

    // The homepage copy follows the app-wide display language: a language change triggers an
    // i18next re-render, which re-selects the matching DE/EN section data.
    const landingPage = loadLandingPageData(resolveApiLanguage(i18n.language));

    const section8Ref = useRef<HTMLDivElement>(undefined);

    return (
        <Container maxWidth="xl">
            <Layout root>
                <LayoutItem>
                    <Header />
                </LayoutItem>
                <LayoutItem body sx={{ overflowX: "hidden", maxWidth: "100%" }}>
                    <Section1 contactRef={section8Ref} data={landingPage.section1} />
                    <Section1a data={landingPage.section1a} />
                    <Section2 data={landingPage.section2} />
                    <Section3 data={landingPage.section3} />
                    <Section4 data={landingPage.section4} />
                    <Section5 data={landingPage.section5} />
                    <Section6 data={landingPage.section6} />
                    <Section7 contactRef={section8Ref} data={landingPage.section7} />
                    <Section8 sr={section8Ref} data={landingPage.section8} />
                </LayoutItem>
            </Layout>
        </Container>
    );
};
